export default {
  outroLine1: "Viel Erfolg!",
  outroLine2: "Ihr REMARKET NOW Sales-Team",
  formerlyB4BMall: "EHEMALS B4B-MALL",
};
